import { render, staticRenderFns } from "./ClaimType.vue?vue&type=template&id=62ee25ae"
import script from "./ClaimType.vue?vue&type=script&lang=js"
export * from "./ClaimType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports